import React from 'react';

export type IconContextValue = {
    variant?: 'filled' | 'stroke';
};

// The context is used for changing the default behavior of the icons. It only
// contains variant prop for now.
export const IconProviderContext = React.createContext<IconContextValue>({});

export const IconProvider = IconProviderContext.Provider;

export const useIconProviderContext = (): IconContextValue => {
    return React.useContext(IconProviderContext);
};
